module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Darnella Ford\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Darnella Ford, the author of "), _c('I', [_vm._v("Crave")]), _vm._v(" and "), _c('I', [_vm._v("Rising")]), _vm._v(", is a spoken-word artist. She performs regularly in the Los Angeles area, where she lives with her daughter. She is currently at work on her next novel.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3oS6PU/tc-custom/9781429904353.jpg?1746160269222",
      "alt": "This image is the cover for the book Choke"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Choke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("For Vanessa, a low-income housing complex in the middle of the desert in El Mirage, Arizona, represents all that is wrong with her life. Her neighbors get it on all night long, she sees an abusive husband kill his wife, and then himself, and her own ex-husband keeps showing up and getting into her pants."), _c('br'), _vm._v("The one bright spot in Vanessa's life is her daughter, Kennedy, and Kennedy's love for the piano. She is practicing to audition for an esteemed music academy that Vanessa can in no way afford---especially after losing her housekeeping job. But Vanessa isn't one to give up, and she'll do anything to help her daughter succeed, even if it means selling her body and soul.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Michael Wiese Productions\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0